import { PluginMarketplace } from "@/features/plugins/components";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/settings/plugins/marketplace")({
	component: MarketplacePage,
});

function MarketplacePage() {
	return <PluginMarketplace />;
}
